import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { AnnualDetailComponent, AnnualDetailYear } from '../Annual-Year/annual-year.model';
import { AnnualDetailEditState } from '../annual-details-navigation.service';
import { AnnualAssessmentDetail, Assessment, EqualizationFactorIntent, TaxableValueInfo } from './assessment.model';
import { AssessmentService, AssessmentViewModel } from './assessment.service';
import { AnnualDetailsService, ComponentFilter } from '../annual-details.service';
import { TaskService } from '../../Task/task.service.upgrade';
import { LaunchTaskModalOptions, LaunchTaskModalService } from '../../Task/launchTaskModal.service';
import { CurrentEntityService } from '../../Common/Entity/CurrentEntityService';
import { CommonModule, DecimalPipe } from '@angular/common';
import {
    MessageBoxButtons,
    MessageBoxResult,
    MessageBoxService,
} from '../../UI-Lib/Message-Box/messagebox.service.upgrade';
import { PopoverDirective, PopoverModule } from 'ngx-bootstrap/popover';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { AnnualDetailsNavigationEventService } from '../annual-details-event.service';
import { ReorderRevisionsModalComponent } from '../Modals/reorder-revisions.component';
import { AllocationService } from '../../Compliance/Allocation/allocation.service';
import { UpgradeNavigationServiceHandler } from '../../Common/Routing/upgrade-navigation-handler.service';
import { Decimal } from 'decimal.js';
import { BusyIndicatorMessageManager } from '../../Busy-Indicator';
import moment from 'moment';
import * as _ from 'lodash';
import { isNumber } from 'lodash';
import { FeatureFlagsService } from '../../Common/FeatureFlags/feature-flags-service';
import { AssessmentComponentExemptionPipe } from '../Pipes/assessment-component-exemption.pipe';
import { AssessmentComponentTypeEnum } from '../../constants.new';
import EntityTypes = Core.EntityTypes;
import TaxableAssessmentTypeEnum = Core.TaxableAssessmentTypeEnum;
import CalcTvUsingTypeEnum = Weissman.Model.CalcTvUsingTypeEnum;
import { HelpContentComponentConfig } from '../../UI-Lib/Help-Tooltip';
import {
    AssessmentTaxableValueHelpComponent,
    AssessmentTaxableValueHelpComponentParams,
} from './AssessmentTaxableValueHelp/assessmentTaxableValueHelp.component';
import { FormsModule } from '@angular/forms';
import { EntityInProgressIndicatorComponent } from '../../Common/Entity/entity.in.progress.indicator.component';
import { EntityAttachmentsComponent } from '../../Attachment/Entity/entity-attachments.component';
import { EntityCommentsButtonComponent } from '../../Comments/Entity-Comments-Button/entityCommentsButton.component';
import { FmvInputComponent } from './assessment-input.component';
import { HelpModule } from '../../UI-Lib/Help-Tooltip/help.module';
import { WeissmanDatetimeComponent } from '../../UI-Lib/Weiss-Datepicker/weissman-datetime.component';
import { WeissmanDateFormatPipe } from '../../UI-Lib/Pipes';
import { BsDropdownDirective, BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CurrencyMaskModule } from '../../UI-Lib/Currency/Mask/currencyMask.module';
import { DragAndDropListModule } from '../../UI-Lib/Directives/Drag-And-Drop-List/dragAndDropList.module';
import { matchTaxableValueIds } from './taxableValueIdMatching';

const ASSESSMENT_ENTITY_TYPE_ID = EntityTypes.AnnualAssessment;

// type lite should have had our back here but no joy, so hand coding this. please don't use outside this component
interface TaskSummaryItemDTO {
    TaskSeriesID: number;
    TaskSeriesTypeID: number;
    Status: string;
    CompletedDateTime?: Date;
    SeriesIsComplete: boolean;
    EntityID: number;
    EntityTypeID: number;
    OriginalEntityID: number;
    TrackDataEnterRefundComplete: boolean;
}

// type lite should have had our back here but no joy, so hand coding this. please don't use outside this component
interface TaskSummaryItemDTOAssessment extends TaskSummaryItemDTO {
    AdjustNoticeIsReady?: boolean;
    ObtainPostDeterminationReady?: boolean;
}

@Component({
    selector: 'assessment',
    templateUrl: './assessment.component.html',
    styleUrl: './assessment.component.scss',
    imports: [
        CommonModule,
        FormsModule,
        PopoverModule,
        HelpModule,
        CurrencyMaskModule,
        EntityInProgressIndicatorComponent,
        EntityAttachmentsComponent,
        EntityCommentsButtonComponent,
        AssessmentComponentExemptionPipe,
        FmvInputComponent,
        WeissmanDatetimeComponent,
        WeissmanDateFormatPipe,
        BsDropdownModule,
        DragAndDropListModule,
    ],
})
export class AssessmentComponent implements OnInit, OnChanges {
    constructor(
        public annualDetailsService: AnnualDetailsService,
        private _allocationService: AllocationService,
        private _assessmentService: AssessmentService,
        private _taskService: TaskService,
        private _launchTaskModalService: LaunchTaskModalService,
        private _currentEntityService: CurrentEntityService,
        private _decimalPipe: DecimalPipe,
        private _messageBox: MessageBoxService,
        private _toastr: ToastrService,
        private _changeDetector: ChangeDetectorRef,
        private _navigationEvent: AnnualDetailsNavigationEventService,
        private _navigationService: UpgradeNavigationServiceHandler,
        private _modalService: BsModalService,
        private _featureFlagService: FeatureFlagsService,
        private _exemptionPipe: AssessmentComponentExemptionPipe,
    ) {}

    @Input() viewModel: AssessmentViewModel;
    @Input() currentYear?: AnnualDetailYear;
    @Input() componentTypes?: any[];
    @Input() editState?: AnnualDetailEditState;
    @Input() taskReadonly: boolean = false;
    @Input() gridNavigationHandler: () => void;
    @Input() compactMode: boolean = false;
    @Input() isDocumentProcessing: boolean = false;
    @Input() isIDP: boolean = false;
    @Input() companyId: number;
    @Input() propertyType: number;
    @Input() viewTaxableValues: boolean;
    @Output() viewModelChange: EventEmitter<AssessmentViewModel> = new EventEmitter<AssessmentViewModel>();
    @Output() AssessmentChanged: EventEmitter<Assessment> = new EventEmitter<Assessment>();
    @ViewChild('renamePopover') renamePopover: PopoverDirective;

    ComponentFilter = ComponentFilter;
    systemLogic: CalcTvUsingTypeEnum = CalcTvUsingTypeEnum.SystemLogic;
    priorYearSetup: CalcTvUsingTypeEnum = CalcTvUsingTypeEnum.PriorYearSetup;
    taskSummaries: TaskSummaryItemDTOAssessment;
    allocationTaskSummaries: TaskSummaryItemDTO;
    originalRevisionName: string;
    revisionName: string;
    revisionOtherName: string;
    taskSummariesLoaded: boolean = false;
    allocationTaskSummariesLoaded: boolean = false;
    showPopover: boolean = false;
    popoverDirection: 'bottom' | 'right' = 'bottom';
    dateChanged: boolean = false;
    AssessmentEntityTypeId: number = ASSESSMENT_ENTITY_TYPE_ID;

    hasAllocationFeature: boolean;
    hasAllocation: boolean;
    isPPParcel: boolean;
    appealByChanged: boolean = false;
    taxableValues: TaxableValueInfo[] = [];

    hasCapComponent: boolean = false;
    capComponentName: string;
    enableCapRule: boolean = false;
    enableTaxableValueOverride: boolean = false;

    private _busyIndicatorMsgManager: BusyIndicatorMessageManager<string> = new BusyIndicatorMessageManager();
    private _nextTempTaxableValueId: number = -1;
    // Number of edits staged in this panel so far; every edit handler goes through setDirty().
    private stagedEditCount = 0;
    // The staged edit count right after the latest Calc TV Using change, to tell whether anything else was edited since.
    private stagedEditCountAfterCalcTvUsingChange = 0;

    ngOnInit(): void {
        this.hasAllocationFeature = this._featureFlagService.featureFlags.enableAllocationFeature;
        this.enableTaxableValueOverride = !!this._featureFlagService.featureFlags?.enableTaxableValueOverride;
        this.isPPParcel = this.propertyType === Core.PropertyTypes.Personal;

        this.viewModelChanged();

        if (this.viewModel) {
            this.setVariablesFromViewModel();
        }

        if (this.compactMode) {
            this.popoverDirection = 'right';
        }

        this.refreshTaxableValuesFromModel();

        this.enableCapRule = true;
        this._checkCapComponentExistence();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (Object.keys(changes).indexOf('viewModel') >= 0 && !changes.viewModel.firstChange) {
            this.viewModelChanged();
        }

        if (Object.keys(changes).indexOf('viewTaxableValues') >= 0 && changes.viewTaxableValues) {
            this._recalculateTaxableValues();
        }

        // This might not strictly-speaking be necessary, but for completeness make sure componentTypes is
        // always synced with the view model
        if (Object.keys(changes).indexOf('componentTypes') >= 0 && this.componentTypes && this.viewModel) {
            this.viewModel.components = this.componentTypes;
        }

        // if (Object.keys(changes).indexOf('revisionName') >= 0){
        //     this.viewModel.model.revisionDesc = ((this.viewModel.model.revisionDesc.toString() == 'Final') || (this.viewModel.model.revisionDesc.toString() == 'Original')) ? this.revisionName : this.revisionOtherName;
        // }
    }

    viewModelChanged(): void {
        if (this.viewModel) {
            this.viewModel.model.annualAssessmentDetails = this.getSortedAnnualAssessmentDetails();
            this.editState.showEditControls = this.viewModel.model !== undefined;
            this.setVariablesFromViewModel();
            this.viewModel.hasWritePermission = this.editState.hasWritePermission;
            this.viewModel.updateModalData();
            this.resetEqFactorLocalState();
            this.getTaskSummaries();
            this.getAllocationTaskSummaries(); // TODO: maybe wrap in feature flag
            if (this.componentTypes) {
                this.viewModel.components = this.componentTypes;
            }
            // Armed here, not in the edit handlers, so a save re-syncs the displayed rows whatever was edited.
            this.viewModel.SavedAssessmentAssigned = () => this.refreshTaxableValuesFromModel();
            this.refreshTaxableValuesFromModel();
        } else {
            this.editState.showEditControls = false;
        }
    }

    get appealByIsInPast(): boolean {
        return moment(this.viewModel.model.appealDeadline).isBefore(moment());
    }

    get appealByIsLaterThanOriginal(): boolean {
        return moment(this.viewModel.model.appealDeadline).isAfter(this.viewModel.model.originalDeadline);
    }

    get isTargetValueGreaterThanTotalFmv(): boolean {
        let typeIdsToReject = [];

        if (
            this._exemptionPipe.transform(this.viewModel.model.annualAssessmentDetails, ComponentFilter.nonexempt)
                .length > 0
        ) {
            typeIdsToReject = [3];
        } else if (
            this._exemptionPipe.transform(this.viewModel.model.annualAssessmentDetails, ComponentFilter.exempt).length >
            0
        ) {
            typeIdsToReject = [2, 3];
        }

        return (
            this.viewModel.currentYear.targetValue &&
            this.viewModel.currentYear.targetValue > this.getTotal('fairMarketValue', typeIdsToReject)
        );
    }

    // Eq. Factor display state remains server-resolved. Edits stage an explicit save intent on the assessment DTO.
    get eqFactorState(): Core.EqualizationFactorDisplayStateDto {
        return this.viewModel?.currentYear?.equalizationFactorState;
    }

    // The server resolves EqualizationFactorState once per AnnualYear (shared by every revision of that
    // year), so it cannot itself flag which specific revision is "latest." Revision selection is already an
    // established, trusted client-side concept (viewModel.isLastAssessment - the same flag used to gate
    // Target Value editability above), so it is used here - not to derive Synchronized/Override/etc. from
    // partial values, but only to downgrade the rendering of an already-resolved state to "Protected" when
    // viewing a historical (non-latest) revision. BlankRuleUnselected is also treated as "nothing to protect"
    // here: the user never opted in on this AnnualYear, so a historical revision has no chosen value to
    // protect and should not surface the Eq. Factor section at all (see showEqFactorSection).
    get eqFactorEffectiveDisplayState(): Core.EqualizationFactorDisplayState {
        const state = this.eqFactorState;
        if (!state) {
            return null;
        }

        const isHistoricalRevision = !this.viewModel.isLastAssessment;
        const hasNothingToProtect =
            state.displayState === Core.EqualizationFactorDisplayState.NoRule ||
            state.displayState === Core.EqualizationFactorDisplayState.DurableOptOut ||
            state.displayState === Core.EqualizationFactorDisplayState.BlankRuleUnselected;

        if (isHistoricalRevision && !hasNothingToProtect) {
            return Core.EqualizationFactorDisplayState.Protected;
        }

        return state.displayState;
    }

    get showEqFactorSection(): boolean {
        const state = this.eqFactorEffectiveDisplayState;
        if (state === null || state === Core.EqualizationFactorDisplayState.NoRule) {
            return false;
        }
        // The user never opted in (BlankRuleUnselected) - only show the checkbox to opt in on the latest
        // revision. A historical revision has nothing to protect/display, so hide the section entirely.
        if (
            (state === Core.EqualizationFactorDisplayState.BlankRuleUnselected ||
                state === Core.EqualizationFactorDisplayState.DurableOptOut) &&
            !this.viewModel.isLastAssessment
        ) {
            return false;
        }
        return true;
    }

    get showEqFactorTextbox(): boolean {
        const state = this.eqFactorEffectiveDisplayState;
        if (state === null) {
            return false;
        }

        if (this.eqFactorIntent === EqualizationFactorIntent.Set) {
            return true;
        }

        return (
            state === Core.EqualizationFactorDisplayState.Synchronized ||
            state === Core.EqualizationFactorDisplayState.Override ||
            state === Core.EqualizationFactorDisplayState.StaleRule ||
            state === Core.EqualizationFactorDisplayState.Protected
        );
    }

    get showEqFactorCheckbox(): boolean {
        const state = this.eqFactorEffectiveDisplayState;
        return (
            this.viewModel.isLastAssessment &&
            this.eqFactorIntent !== EqualizationFactorIntent.Set &&
            (state === Core.EqualizationFactorDisplayState.BlankRuleUnselected ||
                state === Core.EqualizationFactorDisplayState.DurableOptOut)
        );
    }

    get isEqFactorReadOnly(): boolean {
        return (
            !this.editState.editMode ||
            this.viewModel.hasWritePermission === false ||
            this.eqFactorEffectiveDisplayState === Core.EqualizationFactorDisplayState.Protected
        );
    }

    get isEqFactorEstimate(): boolean {
        const state = this.eqFactorState;
        // Check the raw (server-resolved) displayState, not the effective one: a historical revision downgrades
        // the effective state to Protected, but the underlying rule's estimate/actual status still applies and
        // must keep showing the estimate treatment even when read-only.
        return (
            !!state &&
            state.displayState === Core.EqualizationFactorDisplayState.Synchronized &&
            state.ruleIsActual === false
        );
    }

    get isEqFactorOverride(): boolean {
        if (this.eqFactorIntent === EqualizationFactorIntent.Set) {
            return this.eqFactorValue !== this.eqFactorState?.ruleFactor;
        }

        if (this.eqFactorIntent === EqualizationFactorIntent.Revert) {
            return false;
        }

        const state = this.eqFactorEffectiveDisplayState;
        return (
            state === Core.EqualizationFactorDisplayState.Override ||
            state === Core.EqualizationFactorDisplayState.StaleRule
        );
    }

    get eqFactorCheckboxChecked(): boolean {
        return this.eqFactorIntent === EqualizationFactorIntent.Set;
    }

    set eqFactorCheckboxChecked(checked: boolean) {
        if (checked && this.viewModel?.model) {
            this.viewModel.model.equalizationFactorIntent = EqualizationFactorIntent.Set;
            this.viewModel.model.equalizationFactor = this.eqFactorState?.ruleFactor ?? null;
        }
    }

    eqFactorCheckboxChanged(): void {
        if (this.eqFactorCheckboxChecked) {
            this._eqFactorChanged();
        }
    }

    get eqFactorIntent(): EqualizationFactorIntent {
        return this.viewModel?.model?.equalizationFactorIntent ?? EqualizationFactorIntent.None;
    }

    get eqFactorValue(): number {
        if (this.eqFactorIntent === EqualizationFactorIntent.None) {
            return this.eqFactorState?.annualYearFactor ?? null;
        }

        return this.viewModel?.model?.equalizationFactor ?? null;
    }

    set eqFactorValue(value: number) {
        if (!this.viewModel?.model) {
            return;
        }

        this.viewModel.model.equalizationFactor = value;
        this.viewModel.model.equalizationFactorIntent =
            value === null || value === undefined ? EqualizationFactorIntent.OptOut : EqualizationFactorIntent.Set;
        this._eqFactorChanged();
    }

    get showEqFactorRevert(): boolean {
        return (
            !this.isEqFactorReadOnly &&
            this.eqFactorIntent !== EqualizationFactorIntent.Revert &&
            this.isEqFactorOverride
        );
    }

    revertEqFactor(): void {
        this.viewModel.model.equalizationFactor = this.eqFactorState?.ruleFactor ?? null;
        this.viewModel.model.equalizationFactorIntent = EqualizationFactorIntent.Revert;
        this._eqFactorChanged();
    }

    // Initialize the staged request from the canonical state whenever the underlying viewModel changes.
    private resetEqFactorLocalState(): void {
        this.viewModel.model.equalizationFactorIntent = EqualizationFactorIntent.None;
        this.viewModel.model.equalizationFactor = this.eqFactorState?.annualYearFactor ?? null;
    }

    setRevisionName(closeModal: boolean = false): void {
        if (this.revisionName !== 'Other') {
            this.viewModel.model.revisionDesc = this.revisionName;
        } else {
            if ((this.revisionOtherName ? this.revisionOtherName.trim() : '') !== '') {
                this.viewModel.model.revisionDesc = this.revisionOtherName;
            } else {
                this.viewModel.model.revisionDesc = this.originalRevisionName;
            }
        }

        if (closeModal) {
            this.renamePopover.hide();
        }

        this.editState.refreshGrid = true;
        this.editState.refreshActivity = true;
        this.setDirty();
    }

    validateRevisionName(): void {
        if (!this.viewModel.model.revisionDesc) {
            this.viewModel.model.revisionDesc = this.originalRevisionName;
        }
    }

    launchRevisionReorder(): void {
        this.promptAutoSave(
            'Reordering revisions with pending changes will force a save of the current revision. Do you wish to continue?',
        ).then(() => {
            const ref = this._modalService.show(ReorderRevisionsModalComponent);

            ref.content.initialize({
                annualYearID: this.currentYear.annualYearID,
                year: this.currentYear.annualYear1,
                assessments: this.currentYear.annualGridDetails.map((i) => ({
                    id: i.annualAssessmentID,
                    description: i.revisionDesc,
                    sequence: i.revisionNum,
                })),
            });

            const subscription = ref.content.assessmentsReorderedEventEmitter.subscribe(
                // next
                () => {
                    this.editState.refreshGrid = true;
                    this.refreshAssessmentData();
                },
                // error
                () => null,
                // completed
                () => {
                    subscription.unsubscribe();
                    ref.hide();
                },
            );
        });
    }

    componentRatioChange(component: AnnualAssessmentDetail): void {
        if (isNumber(component.displayRatio)) {
            component.ratio = new Decimal(component.displayRatio).dividedBy(100).toNumber();
        }
    }

    // We left this as "any" because this is a generic component type
    // and we don't currently have a model or understand it well enough
    getUnusedComponentTypes(annualAssessmentDetails): any {
        return _.reject(this.viewModel.components, (compType) => {
            // check if this compType has been used by any of the annualAssessmentDetails already
            const compTypeIsInUse = _.some(annualAssessmentDetails, (annualAssessmentDetail: AnnualDetailComponent) => {
                return (
                    annualAssessmentDetail.efAction !== 'delete' &&
                    annualAssessmentDetail.assessmentClassComponentID === compType.assessmentClassComponentID
                );
            });

            let alternateComponentAlreadyInUse = false;

            if (compType.assessmentComponent.assessmentComponentTypeID === 3) {
                alternateComponentAlreadyInUse = _.some(
                    annualAssessmentDetails,
                    function (annualAssessmentDetail: AnnualDetailComponent) {
                        return (
                            annualAssessmentDetail.efAction !== 'delete' &&
                            annualAssessmentDetail.assessmentComponentTypeID === 3
                        );
                    },
                );
            }

            return compTypeIsInUse || alternateComponentAlreadyInUse || !compType.enabled;
        });
    }

    getTaskSummaries(): void {
        if (this.viewModel && this.viewModel.model && this.viewModel.model.annualAssessmentID) {
            //removed a constant value
            this._taskService
                .getTaskSummaryByEntity(this.viewModel.model.annualAssessmentID, EntityTypes.AnnualAssessment)
                .then((response) => {
                    this.taskSummaries = response && response.length > 0 ? response[0] : undefined;

                    this.taskSummariesLoaded = true;
                });
        }
    }

    getAllocationTaskSummaries(): void {
        if (this.viewModel && this.viewModel.model && this.viewModel.model.annualAssessmentID) {
            // Determine annualAssessmentID to use if there are multiple revisions
            const annualAssessmentId =
                this.viewModel.currentYear.annualGridDetails.length > 1
                    ? this.viewModel.currentYear.annualGridDetails[
                          this.viewModel.currentYear.annualGridDetails.length - 1
                      ].annualAssessmentID
                    : this.viewModel.model.annualAssessmentID;

            this._taskService
                .getTaskSummaryByEntity(annualAssessmentId, EntityTypes.AssessmentAllocation)
                .then((response) => {
                    this.allocationTaskSummaries = response && response.length > 0 ? response[0] : undefined;

                    this.allocationTaskSummariesLoaded = true;
                });
        }
    }

    launchTaskModal(): void {
        // step 1: if dirty and in "full" mode aka annual details, save assessment
        // step 2: show toast if auto save is successful
        // step 3: launch modal
        // step 4: on modal close if shouldReloadTasks, refetch assessments
        if (this.editState.getDirty() && !this.compactMode) {
            this.editState.saveHandler().then(() => {
                this.editState.setDirty(false);
                this.viewModel.setEditBackup();
                this._toastr.info('Assessment changes autosaved');
                this._launchTaskModalService
                    .launchTaskModal(
                        this.viewModel.model.annualAssessmentID,
                        ASSESSMENT_ENTITY_TYPE_ID,
                        this.taskReadonly || !this.editState.editMode,
                        undefined,
                        undefined,
                        this.getAddYearPromptOptions(),
                    )
                    .then((shouldReloadTasks) => {
                        if (shouldReloadTasks) {
                            this.getTaskSummaries();
                            this.getAllocationTaskSummaries(); // TODO: feature flag?
                            this.refreshAssessmentData();
                            this._navigationEvent.refreshActivityData();
                            this.editState.setDirty(false);
                            this.editState.refreshGrid = true;
                        }
                    });
            });
        } else {
            this._launchTaskModalService
                .launchTaskModal(
                    this.viewModel.model.annualAssessmentID,
                    ASSESSMENT_ENTITY_TYPE_ID,
                    this.taskReadonly || !this.editState.editMode,
                    undefined,
                    undefined,
                    this.getAddYearPromptOptions(),
                )
                .then((shouldReloadTasks) => {
                    if (shouldReloadTasks) {
                        this.getTaskSummaries();
                        this.getAllocationTaskSummaries(); // TODO: feature flag?
                        this.refreshAssessmentData();
                        this._navigationEvent.refreshActivityData();
                        this.editState.refreshGrid = true;
                    }
                });
        }
    }

    isDeadlineOverridden(): boolean {
        return (
            this.viewModel.model &&
            ((this.viewModel.model.appealDeadline && !this.viewModel.model.originalDeadline) ||
                (this.viewModel.model.appealDeadline &&
                    this.viewModel.model.originalDeadline &&
                    !this.areDeadlinesEqual()))
        );
    }

    revertDateCheck(): void {
        if (!this.areDeadlinesEqual() && !this.viewModel.model.appealDeadline) {
            this.viewModel.model.appealDeadline = this.viewModel.model.originalDeadline;
        }
    }

    /*updateAction(revision): void {
        revision.efAction = revision.efAction === null ? 'update' : revision.efAction
    }*/

    readOnly(): boolean {
        if (this.viewModel.model === undefined) {
            return true;
        }
        return !this.editState.editMode;
    }

    changeActual(): void {
        this.viewModel.model.status = this.viewModel.model.status ? 0 : 1;
    }

    canEditTable(isCapComponent: boolean = false): boolean {
        return (
            this.editState.editMode &&
            (!this.viewModel.isActual() ||
                this._isAdjustNoticeReady() ||
                this._isObtainPostDeterminationReady() ||
                (this.isDocumentProcessing && this.isIDP)) &&
            ((!isCapComponent && !this.viewModel.currentYear.calcProjected) ||
                (isCapComponent &&
                    ((this.enableCapRule && !this.viewModel.currentYear.calcCapProjected) ||
                        (!this.enableCapRule && !this.viewModel.currentYear.calcProjected))))
        );
    }

    hasEditableRow(): boolean {
        return this.editState.editMode && (this.canEditTable() || this.canEditTable(true));
    }

    hasRatioOverride(): boolean {
        return (
            this.editState.editMode &&
            this.viewModel.model.annualAssessmentDetails.some((x) => x.ratio !== x.assessmentClassRatio.assessmentRatio)
        );
    }

    hasFmvOverride(): boolean {
        return this.editState.editMode && this.viewModel.model.annualAssessmentDetails.some((x) => x.fmvOverridden);
    }

    showComponentDropdown(): boolean {
        //Conditions are to show if:
        //1) We are in Edit Mode
        //2) There are still more components to add
        //3) The revision is Not Actual
        //4) The revision is Not Auto Calculated

        return !(
            this.readOnly() ||
            this.getUnusedComponentTypes(this.viewModel.model.annualAssessmentDetails).length === 0 ||
            (this.viewModel.isActual() && !this._isAdjustNoticeReady()) ||
            this.viewModel.currentYear.calcProjected
        );
    }

    //We need better names for this...
    calcDisabled(): string {
        if (this.disableCalc()) {
            return 'disabled';
        } else {
            return '';
        }
    }

    //We really need better names for this...
    disableCalc(): boolean {
        return (
            !this.viewModel.currentYear.calcProjected &&
            _.reject(this.viewModel.currentYear.annualGridDetails, {
                revisionDesc: '<New>',
            }).length > 1
        );
    }

    //Like, seriously we need better names
    someExem(): boolean {
        return _.some(this.viewModel.model.annualAssessmentDetails, {
            assessmentComponentTypeID: 2,
        });
    }

    getTotal(column, typeIdsToReject: number[]): number {
        return this.viewModel.model.annualAssessmentDetails
            .filter((component) => {
                return !_.includes(typeIdsToReject, component.assessmentComponentTypeID);
            })
            .reduce((sum, component) => {
                if (component.efAction === 'delete') {
                    return sum;
                }

                if (column === 'fairMarketValue') {
                    return new Decimal(sum).plus(this.getFairMarketValue(component)).toNumber();
                } else {
                    return new Decimal(sum).plus(Number(component[column])).toNumber();
                }
            }, 0);
    }

    getFairMarketValue(component): number {
        if (component.fairMarketValue !== undefined) {
            const trimmedValue = _.trim(component.fairMarketValue, '#');
            return Number(trimmedValue);
        }
        if (!component.ratio || this.annualDetailsService.parseFMV(component.ratio) === 0) {
            return 0;
        }

        const parsedAssesedValue: number = this.annualDetailsService.parseFMV(component.assessedValue);
        const parsedRatio: number = this.annualDetailsService.parseFMV(component.ratio);

        return new Decimal(parsedAssesedValue).dividedBy(parsedRatio).toNumber();
    }

    areDeadlinesEqual(): boolean {
        const appeal = new Date(this.viewModel.model.appealDeadline);
        const original = new Date(this.viewModel.model.originalDeadline);

        if (appeal && original) {
            return (
                appeal.getFullYear() === original.getFullYear() &&
                appeal.getMonth() === original.getMonth() &&
                appeal.getDate() === original.getDate()
            );
        } else {
            return !appeal && !original;
        }
    }

    reset(annualDetail: AnnualAssessmentDetail): void {
        annualDetail.fmvOverridden = false;
        this.calculate('', annualDetail, 0);
        this.setDirty();
    }

    calculate(
        changed: string,
        component: AnnualAssessmentDetail,
        newValue: number = undefined,
        isFromIdp?: boolean,
    ): void {
        let allowNegatives: boolean = false;

        //set emitted new value, if applicable. This depends on the changed component type
        if (newValue !== undefined) {
            if (changed === 'av') {
                component.assessedValue = newValue;
            } else if (changed === 'fairMarketValue') {
                component.fairMarketValue = newValue;
            }
        }
        if (component.assessmentComponentTypeID === 2) {
            allowNegatives = true;
        }

        //If we're running calculations, something has changed, so mark it
        this.setDirty(true);

        //Process each of the textboxes separately
        switch (changed) {
            case 'ratio':
                component.displayRatio = component.displayRatio ? component.displayRatio : null;
                break;
            case 'av':
                let assessedValue: string;

                if (component.assessedValue) {
                    assessedValue = component.assessedValue.toString();
                } else {
                    assessedValue = '0';
                }
                component.assessedValue = +this.filterNumber(assessedValue, false, allowNegatives);
                this._changeDetector.detectChanges();
                break;
        }

        this.componentRatioChange(component);

        component.efAction = component.efAction === null ? 'update' : component.efAction;

        if (
            !(
                (component.fairMarketValue && component.fairMarketValue.toString().indexOf('#') !== -1) ||
                component[changed] === '-' ||
                component.fmvOverridden ||
                !component.ratio
            )
        ) {
            //Process negatives from the exemptions field
            if (component.assessmentComponentTypeID === 2) {
                if (component.fairMarketValue > 0) {
                    component.fairMarketValue = -Math.abs(component.fairMarketValue);
                }
                if (component.assessedValue > 0) {
                    component.assessedValue = -Math.abs(component.assessedValue);
                }
            } else {
                if (component.fairMarketValue < 0) {
                    component.fairMarketValue = Math.abs(component.fairMarketValue);
                }
                if (component.assessedValue < 0) {
                    component.assessedValue = Math.abs(component.assessedValue);
                }
            }

            if (changed === 'fairMarketValue') {
                component.assessedValue = new Decimal(component.fairMarketValue)
                    .times(component.ratio)
                    .round()
                    .toNumber();
            } else {
                component.fairMarketValue = new Decimal(component.assessedValue)
                    .dividedBy(component.ratio)
                    .round()
                    .toNumber();
            }

            if (this.viewModel) {
                this.viewModel.AssessmentChanged = (model) => {
                    this.viewModelChanged();
                    this.AssessmentChanged.emit(model);
                };

                if (this.AssessmentChanged) {
                    this._recalculateTaxableValues();
                    this._recalculateCapValue();
                    this.AssessmentChanged.emit(this.viewModel.model);
                }
            }
        } else if (component.fmvOverridden) {
            this._recalculateTaxableValues();
            this._recalculateCapValue();
        }

        if (isFromIdp) {
            component.isFromIdp = component.isFromIdp || {};
            component.isFromIdp[changed] = true;
        }
    }

    filterNumber(input: string, hash: boolean, negative: boolean): string {
        if (input === undefined) {
            input = '';
        }
        let clean;

        if (hash && input[0] === '#') {
            clean = input.substring(1);
            if (negative && clean[0] === '-') {
                clean = `-${clean.substring(1).replace(/[^0-9]+/g, '')}`;
            } else {
                clean = clean.replace(/[^0-9]+/g, '');
            }
            clean = `#${clean}`;
        } else {
            if (negative && input[0] === '-') {
                clean = `-${input.substring(1).replace(/[^0-9]+/g, '')}`;
            } else {
                clean = input.replace(/[^0-9]+/g, '');
            }
        }

        return clean;
    }

    maybeRevertToCalcRatio(component: AnnualAssessmentDetail): void {
        if (component.ratio) {
            component.displayRatio = +this._decimalPipe.transform(component.displayRatio, '1.3-3');

            this.calculate('ratio', component);
        } else {
            this.revertToCalcRatio(component);
        }
    }

    revertToCalcRatio(component: AnnualAssessmentDetail): void {
        component.ratio = component.assessmentClassRatio.assessmentRatio;
        component.displayRatio = +this._decimalPipe.transform(component.ratio * 100, '1.3-3');

        this.calculate('ratio', component);
    }

    undoCalcRatio_Click(component: AnnualAssessmentDetail) {
        this.revertToCalcRatio(component);
        this.setDirty();
    }

    makeOverridden(component): void {
        if (component.fairMarketValue[0] === '#') {
            component.fairMarketValue = this.annualDetailsService.parseFMV(component.fairMarketValue);
            component.fmvOverridden = true;
        } else if (!component.fairMarketValue) {
            component.fmvOverridden = false;
            this.calculate('', component);
        } else {
            component.fmvOverridden = false;
        }

        this.AssessmentChanged.emit(this.viewModel.model);
    }

    async addRow(
        component: any,
        valuesToAdd?: {
            fairMarketValue?: number;
            av?: number;
            ratio?: number;
        },
        assessmentVM?: AssessmentViewModel,
    ): Promise<void> {
        const vmToUse = assessmentVM ?? this.viewModel;
        // api/AnnualAssessmentDetail?annualAssessmentID=5202118&assessmentClassComponentID=292&assessmentClassID=8&assessorID=170&annualYear=2016&componentName=Other
        const params = {
            annualAssessmentID: vmToUse.model.annualAssessmentID,
            assessmentClassComponentID: component.assessmentClassComponentID,
            assessmentClassID: component.assessmentClassID,
            assessorID: vmToUse.assessorID,
            annualYear: vmToUse.currentYear.annualYear1,
            componentName: component.componentName,
        };

        return this._assessmentService.getAssessmentComponent(params).then((result: AnnualAssessmentDetail) => {
            const newComponent: AnnualAssessmentDetail = result;

            if (!newComponent.fairMarketValue) {
                newComponent.fairMarketValue = 0;
            }

            if (vmToUse.model.annualAssessmentID !== undefined) {
                newComponent.annualAssessmentID = vmToUse.model.annualAssessmentID;
            }

            newComponent.efAction = 'add';

            // Adding row from Document processing OCR
            if (isNumber(valuesToAdd?.fairMarketValue)) {
                this.calculate('fairMarketValue', newComponent, valuesToAdd.fairMarketValue);
            }
            if (isNumber(valuesToAdd?.av)) {
                this.calculate('av', newComponent, valuesToAdd.av);
            }
            if (isNumber(valuesToAdd?.ratio)) {
                newComponent.displayRatio = valuesToAdd.ratio;
                this.calculate('ratio', newComponent);
            }

            if (valuesToAdd) {
                newComponent.isFromIdp = _.mapValues(valuesToAdd, (x) => true);
            }

            if (this.enableCapRule && result.assessmentComponentTypeID === AssessmentComponentTypeEnum.Cap) {
                this.hasCapComponent = true;
                this.capComponentName = result.componentName;
            }

            vmToUse.model.annualAssessmentDetails.push(newComponent);
            vmToUse.model.annualAssessmentDetails = this.getSortedAnnualAssessmentDetails();
            vmToUse.recalculateVariables();
            this.setDirty(true);
            vmToUse.AssessmentChanged = (model) => {
                this.viewModelChanged();
                this.AssessmentChanged.emit(model);
            };
            this.AssessmentChanged.emit(vmToUse.model);
        });
    }

    deleteComponent(component: AnnualAssessmentDetail): void {
        _.remove(this.viewModel.model.annualAssessmentDetails, component);
        this.setDirty();
        this.viewModel.AssessmentChanged = (model) => {
            this.viewModelChanged();
            this.AssessmentChanged.emit(model);
        };
        this._recalculateTaxableValues();
        this._recalculateCapValue();
        this.AssessmentChanged.emit(this.viewModel.model);
        this._navigationEvent.refreshActivityData();

        if (this.enableCapRule && component.assessmentComponentTypeID === AssessmentComponentTypeEnum.Cap) {
            this.hasCapComponent = false;
        }
    }

    async deleteAssessment(): Promise<void> {
        let message: string = 'Are you sure you want to delete this assessment?';

        if (this.viewModel.currentYear.annualGridDetails.length === 1) {
            message = `WARNING: All related assessment, appeal, tax bill, and compliance information for ${this.viewModel.currentYear.annualYear1} will also be deleted!`;
        }

        const result = await this._messageBox.open({
            title: 'WARNING',
            message: message,
            buttons: MessageBoxButtons.YesNo,
        });

        switch (result) {
            case MessageBoxResult.Yes:
                this.editState.entityLoading = true;
                try {
                    await this._assessmentService.deleteAssessment(this.viewModel.model.annualAssessmentID);
                    this.editState.editMode = false;
                    this.editState.setDirty(false);
                    this.editState.refreshGrid = true;
                    this.editState.staleAppealSavings = true;
                    this._navigationEvent.refreshActivityData();
                    this.gridNavigationHandler();
                } catch (err) {
                    const errorMessage = err?.error?.message || err?.message;
                    if (errorMessage) {
                        this._toastr.error(errorMessage);
                    }
                } finally {
                    this.editState.entityLoading = false;
                }
                break;
            case MessageBoxResult.No:
                break;
        }
    }

    getCommentsModalData(): any {
        const parcel = this._currentEntityService.get();

        return {
            parcelAcctNum: parcel.name,
            parcelID: parcel.id,
            entityTypeID: 7,
            entityID: this.viewModel.model.annualAssessmentID,
            description: `${this.viewModel.currentYear.annualYear1} - ${this.viewModel.model.revisionDesc}`,
            year: this.viewModel.currentYear.annualYear1,
            canEdit: true,
        };
    }

    async autoCalculateRefresh(isCalcCapProjectedChanged: boolean = false): Promise<void> {
        this.viewModel.dirtyAnnualYear = true;
        //if setting autocalculate to true, we must:
        //1) Confirm
        //2) Save the assessment, to store any name/date changes made
        //3) Save the year, which is what triggers the autocalc values to change
        //4) Refetch the assessment to get the autocalculated values
        if (
            (this.viewModel.currentYear.calcProjected && !isCalcCapProjectedChanged) ||
            (this.enableCapRule &&
                this.hasCapComponent &&
                this.viewModel.currentYear.calcCapProjected &&
                isCalcCapProjectedChanged)
        ) {
            const result = await this._messageBox.open({
                title: 'WARNING',
                message: 'Enabling auto calculate will force your revision to be saved. Do you wish to continue?',
                buttons: MessageBoxButtons.YesNo,
            });
            switch (result) {
                case MessageBoxResult.Yes:
                    this.editState.entityLoading = true;
                    await this._assessmentService.saveAssessmentFromViewModel(this.viewModel, false);
                    //this.viewModel.model = result;
                    this.annualDetailsService
                        .saveYear(this.viewModel.currentYear, true)
                        .then(({ rowVersion }: AnnualDetailYear) => {
                            this.viewModel.currentYear.rowVersion = rowVersion;
                            if (
                                this.viewModel.currentYear.calcProjected ||
                                this.viewModel.currentYear.calcCapProjected
                            ) {
                                const currentYearCarryover = this.viewModel.currentYear;
                                this.refreshAssessmentData().then(() => {
                                    this.viewModel.currentYear = currentYearCarryover;
                                    this._recalculateTaxableValues();
                                });
                            }
                        });
                    break;
                case MessageBoxResult.No:
                    if (isCalcCapProjectedChanged) {
                        this.viewModel.currentYear.calcCapProjected = false;
                    } else {
                        this.viewModel.currentYear.calcProjected = false;
                    }
                    break;
            }
        }
        //Save the "auto calculate" in the year, independent of the assessment
        else {
            if (isCalcCapProjectedChanged) {
                this.viewModel.currentYear.calcCapProjected = false;
            } else {
                this.viewModel.currentYear.calcProjected = false;
            }

            this.setDirty();
        }
    }

    targetValueChanged(): void {
        this.viewModel.dirtyTargetValue = true;
    }

    canEditAutoCalculateTaxableValue(): boolean {
        return this.editState.editMode && this.isFinalRevision() && !!this.viewModel.model?.canRecalculateTaxableValue;
    }

    // The control keeps its place (hidden, not removed) while Auto Calculate TV is unchecked, so the panel does not
    // change size as the user toggles the checkbox.
    get isCalcTvUsingApplicable(): boolean {
        return this.enableTaxableValueOverride && !!this.viewModel?.model?.isCalcTvUsingRelevant;
    }

    // Calc TV Using only means something while the year is Auto Calculate TV and the prior Tax Year carries a setup forward.
    // The Auto Calculate TV checkbox is read live, so the control follows it while the user toggles it.
    get showCalcTvUsing(): boolean {
        return (
            this.enableTaxableValueOverride &&
            !!this.viewModel?.model?.isCalcTvUsingRelevant &&
            this.viewModel.currentYear?.autoCalculateTaxableValue === true
        );
    }

    get calcTvUsingLabel(): string {
        return this.getCalcTvUsingLabel(this.viewModel.currentYear.calcTVUsing);
    }

    getCalcTvUsingLabel(calcTvUsing: CalcTvUsingTypeEnum): string {
        return calcTvUsing === CalcTvUsingTypeEnum.PriorYearSetup ? 'Prior Year Setup' : 'System Logic';
    }

    canEditCalcTvUsing(): boolean {
        return this.canEditAutoCalculateTaxableValue();
    }

    // Prior Year Setup can only be chosen when the prior Tax Year has taxable values to carry forward; the server enforces it.
    isPriorYearSetupOptionDisabled(): boolean {
        return (
            !this.viewModel.model.priorYearTaxableValues?.length &&
            this.viewModel.storedCalcTvUsing !== CalcTvUsingTypeEnum.PriorYearSetup
        );
    }

    // The rows shown for Prior Year Setup before Save are a preview of the prior Tax Year's rows; their Tax Authority
    // mappings only exist once the setup is saved.
    get isPriorYearSetupPreview(): boolean {
        return this.isPriorYearSetup && this.viewModel.hasCalcTvUsingChanged;
    }

    calcTvUsingChanged(): void {
        // The state to go back to when the confirmation is declined is the one before the first change of the edit
        // session; later changes (including going back to the original value) must not replace it.
        const isFirstChange = !this.viewModel.CalcTvUsingDeclined;
        const wasDirty = this.editState.getDirty();
        const wasAnnualYearDirty = this.viewModel.dirtyAnnualYear;
        const wasAppealSavingsStale = this.editState.staleAppealSavings;
        const wasGridRefreshNeeded = this.editState.refreshGrid;

        this.viewModel.rememberTaxableValuesBeforeCalcTvUsingChange();
        this.setDirty();
        this.viewModel.dirtyAnnualYear = true;
        this.viewModel.AssessmentChanged = (model) => {
            this.viewModelChanged();
            this.AssessmentChanged.emit(model);
        };

        this.stagedEditCountAfterCalcTvUsingChange = this.stagedEditCount;

        if (isFirstChange) {
            this.viewModel.CalcTvUsingDeclined = () => {
                if (!wasDirty && this.stagedEditCount === this.stagedEditCountAfterCalcTvUsingChange) {
                    this.editState.setDirty(false);
                    this.editState.staleAppealSavings = wasAppealSavingsStale;
                    this.editState.refreshGrid = wasGridRefreshNeeded;
                    this.viewModel.dirtyAnnualYear = wasAnnualYearDirty;
                }
            };
        }

        if (!this.viewModel.hasCalcTvUsingChanged) {
            // Back to the original value: the rows return to what they were before the change.
            this.viewModel.restoreTaxableValuesBeforeCalcTvUsingChange();
            this.viewModelChanged();
            return;
        }

        if (this.viewModel.currentYear.calcTVUsing === CalcTvUsingTypeEnum.PriorYearSetup) {
            this.previewPriorYearSetup();
        } else {
            this._recalculateTaxableValues();
        }
    }

    autoCalculateTaxableValueChanged(): void {
        const wasDirty = this.editState.getDirty();
        const wasAnnualYearDirty = this.viewModel.dirtyAnnualYear;
        const wasAppealSavingsStale = this.editState.staleAppealSavings;
        const wasGridRefreshNeeded = this.editState.refreshGrid;

        this.setDirty();
        this.viewModel.dirtyAnnualYear = true;
        // Lets Cancel bring the taxable values shown here back to the restored model, as the other edit handlers do.
        this.viewModel.AssessmentChanged = (model) => {
            this.viewModelChanged();
            this.AssessmentChanged.emit(model);
        };

        if (!this.viewModel.currentYear.autoCalculateTaxableValue && this.viewModel.hasCalcTvUsingChanged) {
            // Calc TV Using only applies to an Auto Calculate TV year, so a choice made before unchecking it is dropped
            // together with the rows previewed for it.
            this.viewModel.restoreCalcTvUsing();
            this.viewModel.restoreTaxableValuesBeforeCalcTvUsingChange();
            this.viewModelChanged();
        }

        if (this.viewModel.currentYear.autoCalculateTaxableValue) {
            this.viewModel.rememberTaxableValuesBeforeAutoSwitch();

            // Declining the confirmation undoes the switch; if nothing else was staged before or after it, the edit
            // session has no changes left, so Cancel must not warn about discarding any.
            const stagedEditCountAfterSwitch = this.stagedEditCount;
            this.viewModel.AutoSwitchDeclined = () => {
                if (!wasDirty && this.stagedEditCount === stagedEditCountAfterSwitch) {
                    this.editState.setDirty(false);
                    this.editState.staleAppealSavings = wasAppealSavingsStale;
                    this.editState.refreshGrid = wasGridRefreshNeeded;
                    this.viewModel.dirtyAnnualYear = wasAnnualYearDirty;
                }
            };

            this._recalculateTaxableValues();
        } else if (this.taxableValues?.length) {
            // The rows shown become the Manual rows, which the server saves by id. They are matched to the saved rows
            // now, while their values still are the saved ones, as editing the values afterwards would make that
            // impossible.
            this.taxableValues = this._preserveTaxableValueIds(this.taxableValues, this._getSavedTaxableValues());
            this.viewModel.model.taxableValues = this.taxableValues;

            // A row without a saved id is only derived on this screen (e.g. from a component added in this edit
            // session), so the server has nothing to convert. Staging it as an edit makes Save send and persist it.
            if (this.taxableValues.some((x) => !(x.annualAssessmentTaxableValueId > 0))) {
                this._stageTaxableValuesChange();
            }
        }
    }

    get isManualTaxableValueMode(): boolean {
        return !!this.viewModel?.currentYear && this.viewModel.currentYear.autoCalculateTaxableValue === false;
    }

    // Structure edits (add/remove/rename/reorder) follow the same Manual mode + edit mode + Current
    // Revision gate as the Auto Calculate TV control itself, and are locked by canRecalculateTaxableValue
    // in the same way: a revision that cannot recalculate its taxable values cannot have them restructured.
    canEditTaxableValueStructure(): boolean {
        return (
            this.enableTaxableValueOverride &&
            this.isManualTaxableValueMode &&
            this.editState?.editMode &&
            this.isFinalRevision() &&
            !!this.viewModel.model?.canRecalculateTaxableValue
        );
    }

    // A Tax Year without a Tax Rate Area or Tax Authority is limited to a single taxable value, so adding rows is
    // hidden for it. The server enforces the same rule on save.
    canAddTaxableValueRow(): boolean {
        return this.canEditTaxableValueStructure() && !!this.viewModel.model?.canAddTaxableValue;
    }

    // Drives the hover/help hint shown on non-Current revisions directing the user to the Current Revision
    // by its displayed name.
    showTaxableValueCurrentRevisionHint(): boolean {
        return this.enableTaxableValueOverride && this.isManualTaxableValueMode && !this.isFinalRevision();
    }

    getTaxableValueCurrentRevisionHintText(): string {
        return this.editState?.editMode
            ? `Taxable values can only be edited from the Current Revision (${this.currentRevisionDisplayName}).`
            : `Taxable values are maintained on the Current Revision (${this.currentRevisionDisplayName}), where you can also see the Tax Authorities that use each value.`;
    }

    // In Manual mode, and in a Prior Year Setup year, the taxable value help lists the Tax Authorities mapped to the
    // row. The help is only available on the Current Revision; the mappings of the other revisions are edited in the Bill
    // Cluster Tax Rate Details dialog.
    showTaxableValueUsage(): boolean {
        return (
            this.enableTaxableValueOverride &&
            (this.isManualTaxableValueMode || this.isPriorYearSetup) &&
            !this.isPriorYearSetupPreview
        );
    }

    // A Prior Year Setup year is Auto Calculate TV but carries the prior year's rows and Tax Authority mappings.
    get isPriorYearSetup(): boolean {
        return (
            !!this.viewModel?.currentYear &&
            this.viewModel.currentYear.autoCalculateTaxableValue === true &&
            this.viewModel.currentYear.calcTVUsing === CalcTvUsingTypeEnum.PriorYearSetup
        );
    }

    isTaxableValueInfoDisabled(): boolean {
        // The help of a previewed Prior Year Setup row tells the user to save, so it is available even for a single row.
        if (this.isPriorYearSetupPreview) {
            return false;
        }

        if (this.showTaxableValueUsage()) {
            return !this.isFinalRevision();
        }

        return this.taxableValues.length === 1;
    }

    get currentRevisionDisplayName(): string {
        const annualGridDetails = this.viewModel?.currentYear?.annualGridDetails;

        if (!annualGridDetails || annualGridDetails.length === 0) {
            return '';
        }

        const maxRevisionNum = Math.max(...annualGridDetails.map((d) => d.revisionNum));
        return annualGridDetails.find((d) => d.revisionNum === maxRevisionNum)?.revisionDesc ?? '';
    }

    addTaxableValueRow(): void {
        if (!this.canAddTaxableValueRow()) {
            return;
        }

        const newRow = {
            // Existing rows have positive database ids; new/unsaved rows get a unique negative
            // placeholder id so the drag-and-drop list can track item identity before saving.
            // The backend treats any id it doesn't recognize as a new row regardless of its value.
            annualAssessmentTaxableValueId: this._nextTempTaxableValueId--,
            sequence: this.taxableValues.length + 1,
            description: null,
            assessedValue: 0,
            marketValue: 0,
            taxAmount: 0,
            taxAuthorityIds: [],
            isNew: true,
        } as TaxableValueInfo;

        this.taxableValues = [...this.taxableValues, newRow];
        this._stageTaxableValuesChange();
        this.setDirty();
    }

    async deleteTaxableValueRow(row: TaxableValueInfo): Promise<void> {
        if (!this.canEditTaxableValueStructure()) {
            return;
        }

        if (this.taxableValues.length <= 1) {
            this._toastr.error('At least one taxable value must remain and cannot be deleted.');
            return;
        }

        const stagedPosition = this.taxableValues.indexOf(row) + 1;

        if (stagedPosition === 1 && row.taxAuthorityIds?.length > 0) {
            this._toastr.error(
                'The first taxable value is used by one or more Tax Authority Line Items and cannot be deleted.',
            );
            return;
        }

        const hasEnteredValues = !!row.assessedValue || !!row.marketValue;
        const isUsedByTaxAuthorities = row.taxAuthorityIds?.length > 0;

        // The Tax Authorities that use the row are reassigned to the first taxable value when the change is saved,
        // so the user is warned about that here, before the row is removed from the edit session.
        if (isUsedByTaxAuthorities || hasEnteredValues) {
            const result = await this._messageBox.open({
                title: 'Delete Taxable Value',
                message: isUsedByTaxAuthorities
                    ? this._getReassignmentWarning(row)
                    : 'This taxable value has entered amounts. Are you sure you want to delete it?',
                buttons: MessageBoxButtons.YesNo,
            });

            if (result !== MessageBoxResult.Yes) {
                return;
            }
        }

        // A saved row is reported to the server as deleted, along with the position the user saw it in, so the
        // server can tell whether it was the first taxable value. A row that was never saved is simply dropped.
        if (row.annualAssessmentTaxableValueId > 0) {
            this.viewModel.model.deletedTaxableValues = [
                ...(this.viewModel.model.deletedTaxableValues ?? []),
                { ...row, sequence: stagedPosition, isDeleted: true },
            ];
        }

        this.taxableValues = this.taxableValues.filter((x) => x !== row);
        this._renumberTaxableValues();
        this.setDirty();
    }

    renameTaxableValueRow(row: TaxableValueInfo, name: string): void {
        if (!this.canEditTaxableValueStructure()) {
            return;
        }

        row.description = name;
        this._stageTaxableValuesChange();
        this.setDirty();
    }

    // Invoked by ws-dnd-list once the user drops a dragged row; reordered already reflects the new
    // row order, we just need to persist it back onto the staged model and renumber Sequence.
    onTaxableValuesReordered(reordered: TaxableValueInfo[]): void {
        if (!this.canEditTaxableValueStructure()) {
            return;
        }

        this.taxableValues = reordered;
        this._renumberTaxableValues();
        this.setDirty();
    }

    onTaxableValueAmountEdited(row: TaxableValueInfo, field: 'assessedValue' | 'marketValue', value: number): void {
        row[field] = value;
        this.taxableValueAmountChanged();
    }

    taxableValueAmountChanged(): void {
        this._stageTaxableValuesChange();
        this.setDirty();
    }

    private _getReassignmentWarning(row: TaxableValueInfo): string {
        const firstRow = this.taxableValues[0];
        const firstRowLabel = firstRow.description ? `Taxable (${firstRow.description})` : 'Taxable';
        const taxAuthorityNames = _.uniq(
            (this.viewModel.model?.taxAuthoritiesInfo ?? [])
                .filter((x) => row.taxAuthorityIds.includes(x.taxAuthorityId))
                .map((x) => x.taxAuthorityName),
        ).sort();
        const usedBy = taxAuthorityNames.length
            ? `The following Tax Authorities use this taxable value: ${taxAuthorityNames.join(', ')}.`
            : 'One or more Tax Authorities use this taxable value.';

        return `${usedBy} If you delete it, they will be reassigned to ${firstRowLabel}. Are you sure you want to delete it?`;
    }

    private _renumberTaxableValues(): void {
        this.taxableValues.forEach((row, i) => {
            row.sequence = i + 1;
        });
        this._stageTaxableValuesChange();
    }

    private _stageTaxableValuesChange(): void {
        this.viewModel.model.taxableValues = this.taxableValues;
        this.viewModel.model.taxableValuesEdited = true;

        // Mirrors the pattern used by calculate()/addRow()/deleteComponent(): re-arms the callback the
        // view model invokes on cancelEdit() so this.taxableValues gets re-synced from the reverted
        // model. Without this, cancelling after a taxable-value-only edit (no component field ever
        // touched) would revert the model but leave the staged taxableValues array showing the
        // unsaved edit.
        this.viewModel.AssessmentChanged = (model) => {
            this.viewModelChanged();
            this.AssessmentChanged.emit(model);
        };
    }

    // Note: finalRevision is only set when a user explicitly reorders revisions, so it cannot be used
    // to reliably identify the latest/final revision (e.g. it is never true for a single-revision year).
    // annualGridDetails is returned ordered by RevisionNum descending, so compare against the max
    // revisionNum rather than assuming a fixed array position.
    private isFinalRevision(): boolean {
        const annualGridDetails = this.viewModel.currentYear?.annualGridDetails;

        if (!annualGridDetails || annualGridDetails.length === 0) {
            return false;
        }

        const maxRevisionNum = Math.max(...annualGridDetails.map((d) => d.revisionNum));

        return this.viewModel.model?.revisionNum === maxRevisionNum;
    }

    onAppealDeadlineChanged(): void {
        this.setDirty();
        this.editState.staleAppealStatus = true;
        this.editState.refreshActivity = true;
        this.appealByChanged = true;
    }

    setDirty(autoOverride?: boolean): void {
        this.stagedEditCount++;

        if (autoOverride) {
            this.editState.dataOverridden(true);
        } else {
            this.editState.setDirty(true);
        }
        this.editState.staleAppealSavings = true;
        this.editState.refreshGrid = true;
    }

    blurPopover($event): void {
        $event.preventDefault();
        $event.target.blur();
    }

    getSortedAnnualAssessmentDetails(): AnnualAssessmentDetail[] {
        return _.sortBy(this.viewModel.model.annualAssessmentDetails, (component) => {
            return component.sequence;
        });
    }

    resetAppealDeadline_click(): void {
        this.viewModel.model.appealDeadline = this.viewModel.model.originalDeadline;
        this.appealByChanged = false;
        this.setDirty();
    }

    goToAllocation(): void {
        this._allocationService.navigationParcelId = this.viewModel.parcelID;

        if (!this.hasAllocation) {
            this._createAllocation();
            return;
        }

        this._navigationService.go('allocationDetails', {
            allocationId: this.viewModel.model.allocationId,
        });
    }

    launchAllocationTaskModal() {
        // Determine the annualAssessmentID to use if there are multiple revisions
        const annualAssessmentId =
            this.viewModel.currentYear.annualGridDetails.length > 1
                ? this.viewModel.currentYear.annualGridDetails[this.viewModel.currentYear.annualGridDetails.length - 1]
                      .annualAssessmentID
                : this.viewModel.model.annualAssessmentID;

        // step 1: if dirty and in "full" mode aka annual details, save assessment
        // step 2: show toast if auto save is successful
        // step 3: launch modal
        // step 4: on modal close if shouldReloadTasks, refetch assessments
        if (this.editState.getDirty() && !this.compactMode) {
            this.editState.saveHandler().then(() => {
                this.editState.setDirty(false);
                this.viewModel.setEditBackup();
                this._toastr.info('Assessment Allocations changes autosaved');
                this._launchTaskModalService
                    .launchTaskModal(
                        annualAssessmentId,
                        EntityTypes.AssessmentAllocation,
                        this.taskReadonly || !this.editState.editMode,
                    )
                    .then((shouldReloadTasks) => {
                        if (shouldReloadTasks) {
                            this.getAllocationTaskSummaries(); // TODO: feature flag?
                            this.refreshAssessmentData();
                            this._navigationEvent.refreshActivityData();
                            this.editState.setDirty(false);
                            this.editState.refreshGrid = true;
                        }
                    });
            });
        } else {
            this._launchTaskModalService
                .launchTaskModal(
                    annualAssessmentId,
                    EntityTypes.AssessmentAllocation,
                    this.taskReadonly || !this.editState.editMode,
                )
                .then((shouldReloadTasks) => {
                    if (shouldReloadTasks) {
                        this.getAllocationTaskSummaries(); // TODO: feature flag?
                        this.refreshAssessmentData();
                        this._navigationEvent.refreshActivityData();
                        this.editState.refreshGrid = true;
                    }
                });
        }
    }

    get showBottomLine(): boolean {
        return (
            this.viewTaxableValues &&
            this.viewModel &&
            (this.viewModel.model?.taxableValues?.length !== 0 ||
                this.viewModel.model?.annualAssessmentDetails?.some(
                    (x) => x.assessmentComponentTypeID === AssessmentComponentTypeEnum.Adjustment,
                ))
        );
    }

    getTaxableInfoComponent(
        taxableValueInfo: TaxableValueInfo,
    ): HelpContentComponentConfig<AssessmentTaxableValueHelpComponent, AssessmentTaxableValueHelpComponentParams> {
        const showUsage = this.showTaxableValueUsage();

        return {
            component: AssessmentTaxableValueHelpComponent,
            componentParams: {
                currentTaxableValue: showUsage
                    ? { ...taxableValueInfo, taxAuthorityIds: this._getMappedTaxAuthorityIds(taxableValueInfo) }
                    : taxableValueInfo,
                otherTaxableValues: this.taxableValues.filter(
                    (x) => x.assessedValue !== taxableValueInfo.assessedValue,
                ),
                manualUsageTaxAuthorities: showUsage ? (this.viewModel.model?.taxAuthoritiesInfo ?? []) : undefined,
                isUnsavedPreview: this.isPriorYearSetupPreview,
            },
        };
    }

    // After a save the view model holds the refreshed taxable values (with their Tax Authority mappings), while
    // this.taxableValues can still hold rows derived before the save. Rows that have an id are matched to the model
    // row by id. Rows without an id (new or previewed rows) have no saved mappings, so they use their own list.
    private _getMappedTaxAuthorityIds(taxableValueInfo: TaxableValueInfo): number[] {
        const hasId = taxableValueInfo.annualAssessmentTaxableValueId !== undefined;
        const modelRow = hasId
            ? this.viewModel.model?.taxableValues?.find(
                  (x) => x.annualAssessmentTaxableValueId === taxableValueInfo.annualAssessmentTaxableValueId,
              )
            : undefined;

        return modelRow?.taxAuthorityIds ?? taxableValueInfo.taxAuthorityIds ?? [];
    }

    private _isAdjustNoticeReady(): boolean {
        return this.taskSummaries && this.taskSummaries.AdjustNoticeIsReady;
    }

    private _isObtainPostDeterminationReady(): boolean {
        return this.taskSummaries && this.taskSummaries.ObtainPostDeterminationReady;
    }

    private async _createAllocation(): Promise<void> {
        try {
            await this.annualDetailsService.preNavigateWarn(this.editState);
        } catch (e) {
            return;
        }

        const busyMsgId = 'loading';
        this._busyIndicatorMsgManager.add('Creating Allocation', busyMsgId);

        try {
            const model: Compliance.AllocationCreateModel = {
                annualAssessmentId: this.viewModel.model.annualAssessmentID,
            };
            const result = await this._allocationService.createAllocation(this.companyId, model);
            this.viewModel.model.allocationId = result.allocationId;
            this.hasAllocation = true;
            this.goToAllocation();
        } finally {
            this._busyIndicatorMsgManager.remove(busyMsgId);
        }
    }

    private setVariablesFromViewModel() {
        //Set initial revision name for the rename modal radio button list
        if (
            this.viewModel.model.revisionDesc.toString() == 'Final' ||
            this.viewModel.model.revisionDesc.toString() == 'Original' ||
            this.viewModel.model.revisionDesc.toString() == 'Forecast'
        ) {
            this.revisionName = this.viewModel.model.revisionDesc;
        } else {
            this.revisionName = 'Other';
            this.revisionOtherName = this.viewModel.model.revisionDesc;
        }

        if (!this.viewModel.currentYear && this.currentYear) {
            this.viewModel.currentYear = this.currentYear;
        }

        this.hasAllocation = !!this.viewModel.model.allocationId;

        this._checkCapComponentExistence();

        this.viewModel.recalculateVariables();
    }

    private promptAutoSave(message: string): Promise<void> {
        return new Promise((resolve, reject) => {
            if (this.editState.getDirty() && !this.compactMode) {
                return this._messageBox
                    .open({
                        title: 'WARNING',
                        message: message,
                        buttons: MessageBoxButtons.YesNo,
                    })
                    .then((result) => {
                        switch (result) {
                            case MessageBoxResult.Yes:
                                return this.editState.saveHandler().then(
                                    () => {
                                        this.editState.setDirty(false);
                                        this.viewModel.setEditBackup();
                                        this._toastr.success('Successfully saved.');
                                        resolve();
                                    },
                                    () => reject(),
                                );

                            default:
                                reject();
                                break;
                        }
                    });
            }

            resolve();
        });
    }

    // Only Annual Details hosts the Add Year dialog; compact mode (Document Processing) never prompts.
    private getAddYearPromptOptions(): LaunchTaskModalOptions {
        if (this.compactMode) {
            return undefined;
        }

        return {
            onAddYearPrompt: (prompt: Core.AddYearPromptInfo): Promise<void> =>
                this._navigationEvent.requestAddYear(prompt.annualYear),
        };
    }

    private refreshAssessmentData(): Promise<void> {
        return this._assessmentService
            .getAssessmentViewModelByID(
                this.viewModel.model.annualAssessmentID,
                this.viewModel.assessorID,
                this.viewModel.parcelID,
                this.viewModel.parcelAcctNum,
                this.viewModel.currentYear,
            )
            .then((refreshResult: AssessmentViewModel) => {
                _.assign(this.viewModel, refreshResult);
                this.setVariablesFromViewModel();
                this.editState.entityLoading = false;
                this.viewModel.beginEdit();
                this.AssessmentChanged.emit(this.viewModel.model);
                this._navigationEvent.refreshAnnualYear();
            });
    }

    private _getUniqueTaxable(totals: TaxableValueInfo[]): TaxableValueInfo[] {
        const uniqueTotals = new Map<string, TaxableValueInfo>();

        function getKey(x: TaxableValueInfo): string {
            return JSON.stringify({ assessedValue: x.assessedValue, fairMarketValue: x.marketValue });
        }

        const result = totals.filter((x: TaxableValueInfo) => {
            const key = getKey(x);
            if (uniqueTotals.has(key)) {
                const uniqueTotal = uniqueTotals.get(key);
                uniqueTotal.taxAmount += x.taxAmount;
                uniqueTotal.taxableAssessmentNames.push(x.taxableAssessmentName);
                return false;
            }

            x.taxableAssessmentNames = [x.taxableAssessmentName];
            uniqueTotals.set(key, x);
            return true;
        });

        result.forEach((x) => {
            const taxableValues = totals.filter((y) => getKey(y) === getKey(x));
            x.taxAuthorityCategories = taxableValues.map((y) => y.taxAuthorityCategory);
            x.taxAuthorityNames = taxableValues.map((x) => x.taxAuthorityName);
            // Switching to Manual mode maps the Tax Authorities to the taxable values with the same values, so the
            // same mapping is previewed by the taxable value help before it is saved.
            x.taxAuthorityIds = taxableValues.map((y) => y.taxAuthorityId).filter((id) => id !== undefined);
            x.taxableAssessmentNames = this._assessmentService.getUniqueValues(x.taxableAssessmentNames);
        });

        return result;
    }

    private _eqFactorChanged(): void {
        this.setDirty();
        this.viewModel.AssessmentChanged = (model) => {
            this.viewModelChanged();
            this.AssessmentChanged.emit(model);
        };
        this._recalculateTaxableValues();
        this.AssessmentChanged.emit(this.viewModel.model);
    }

    private _getEffectiveEqualizationFactor(): number {
        if (!this._featureFlagService.featureFlags?.enableEqualizer) {
            return 1;
        }

        switch (this.eqFactorIntent) {
            case EqualizationFactorIntent.Set:
                return this.viewModel.model.equalizationFactor ?? 1;
            case EqualizationFactorIntent.OptOut:
                return 1;
            case EqualizationFactorIntent.Revert:
                return this.eqFactorState?.ruleFactor ?? 1;
            default:
                return this.eqFactorState?.annualYearFactor ?? 1;
        }
    }

    private _applyEqualizationFactorPreview(assessedValue: number): number {
        const factor = this._getEffectiveEqualizationFactor();
        if (factor === 1) {
            return assessedValue;
        }

        return new Decimal(assessedValue).times(factor).toDecimalPlaces(0, Decimal.ROUND_HALF_EVEN).toNumber();
    }

    private refreshTaxableValuesFromModel(): void {
        if (!this.viewTaxableValues || !this.viewModel) {
            return;
        }

        this.taxableValues = this.viewModel.model?.taxableValues?.map((x) => {
            return {
                annualAssessmentTaxableValueId: x.annualAssessmentTaxableValueId,
                assessedValue: x.assessedValue,
                marketValue: x.marketValue,
                taxAmount: x.taxAmount,
                sequence: x.sequence,
                description: x.description,
                taxAuthorityIds: x.taxAuthorityIds ?? [],
            } as TaxableValueInfo;
        });
        this._recalculateTaxableValues();
    }

    private _recalculateTaxableValues() {
        // Manual Taxable Value mode taxable values are user-managed (add/remove/rename/reorder/edit), and a Prior Year
        // Setup year carries the prior year's rows. Neither is derived from components, so this Auto-mode derivation
        // must never run/overwrite them.
        if (this.isManualTaxableValueMode || this.isPriorYearSetup) {
            return;
        }

        if (this.viewTaxableValues && this.viewModel) {
            let taxableValues: TaxableValueInfo[] = [];

            if (this.viewModel.model?.taxAuthoritiesInfo?.length) {
                this.viewModel.model.taxAuthoritiesInfo.forEach((taxAuthority) => {
                    let taxableComponents: AnnualAssessmentDetail[] = [];
                    let taxableAssessmentName = taxAuthority.taxableAssessmentTypeName;

                    switch (taxAuthority.taxableAssessmentTypeId) {
                        case Core.TaxableAssessmentTypeEnum.TotalAV:
                            taxableComponents = this.viewModel.model.annualAssessmentDetails.filter(
                                (y) => y.assessmentComponentTypeID === +AssessmentComponentTypeEnum.Normal,
                            );
                            break;
                        case Core.TaxableAssessmentTypeEnum.AlternateAV:
                            taxableComponents = this.viewModel.model.annualAssessmentDetails.filter(
                                (y) => y.assessmentComponentTypeID === +AssessmentComponentTypeEnum.Cap,
                            );

                            if (taxableComponents.length === 0) {
                                taxableComponents = this.viewModel.model.annualAssessmentDetails.filter(
                                    (y) => y.assessmentComponentTypeID === +AssessmentComponentTypeEnum.Normal,
                                );
                                taxableAssessmentName = 'Total AV';
                            }
                            break;
                        case Core.TaxableAssessmentTypeEnum.LandOnly:
                            taxableComponents = this.viewModel.model.annualAssessmentDetails.filter(
                                (y) => y.assessmentClassComponent.assessmentComponent.isLandComponent,
                            );
                            break;
                        case TaxableAssessmentTypeEnum.LowerOfTotalAvAndAlternateAv:
                            taxableComponents = this.viewModel.model.annualAssessmentDetails.filter(
                                (y) =>
                                    y.assessmentComponentTypeID === +AssessmentComponentTypeEnum.Normal ||
                                    y.assessmentComponentTypeID === +AssessmentComponentTypeEnum.Cap,
                            );
                            break;
                    }

                    const exemptions = this.viewModel.model.annualAssessmentDetails.filter((y) =>
                        taxAuthority.exemptionComponentIds.includes(
                            y.assessmentClassComponent && y.assessmentClassComponent.assessmentComponentID,
                        ),
                    );

                    if (
                        taxAuthority.taxableAssessmentTypeId !== TaxableAssessmentTypeEnum.LowerOfTotalAvAndAlternateAv
                    ) {
                        const allComponents = [...taxableComponents, ...exemptions];

                        const result = allComponents.reduce(
                            (taxableTotal, component) => {
                                const adjustmentAmount =
                                    component.assessmentClassComponent &&
                                    component.assessmentClassComponent.assessmentComponentTypeID ===
                                        AssessmentComponentTypeEnum.Adjustment
                                        ? component.assessedValue
                                        : 0;
                                taxableTotal.adjustmentAssessedValue += adjustmentAmount;

                                taxableTotal.assessedValue += component.assessedValue;
                                taxableTotal.marketValue += component.fairMarketValue;

                                return taxableTotal;
                            },
                            { assessedValue: 0, marketValue: 0 } as TaxableValueInfo,
                        );

                        result.taxAuthorityId = taxAuthority.taxAuthorityId;
                        result.taxAuthorityName = taxAuthority.taxAuthorityName;
                        result.taxAuthorityCategory = taxAuthority.taxAuthorityCategoryName;
                        result.taxableAssessmentName = taxableAssessmentName;
                        result.adjustmentAssessedValue = exemptions.reduce(
                            (total, component) => (total += component.assessedValue),
                            0,
                        );

                        if (result.assessedValue < 0) {
                            result.assessedValue = 0;
                            result.hadNegativeAssessedValue = true;
                        }

                        if (result.marketValue < 0) {
                            result.marketValue = 0;
                            result.hadNegativeMarketValue = true;
                        }

                        result.assessedValue = this._applyEqualizationFactorPreview(result.assessedValue);
                        result.taxAmount = result.assessedValue * taxAuthority.rate;

                        taxableValues.push(result);
                    } else {
                        const avComponents = [
                            ...taxableComponents.filter(
                                (y) => y.assessmentComponentTypeID === +AssessmentComponentTypeEnum.Normal,
                            ),
                            ...exemptions,
                        ];
                        const totalAV = avComponents.reduce(
                            (taxableTotal, component) => {
                                taxableTotal.assessedValue += component.assessedValue;
                                taxableTotal.marketValue += component.fairMarketValue;

                                return taxableTotal;
                            },
                            { assessedValue: 0, marketValue: 0 } as TaxableValueInfo,
                        );
                        totalAV.taxAuthorityId = taxAuthority.taxAuthorityId;
                        totalAV.taxAuthorityName = taxAuthority.taxAuthorityName;
                        totalAV.taxAuthorityCategory = taxAuthority.taxAuthorityCategoryName;
                        totalAV.adjustmentAssessedValue = exemptions.reduce(
                            (total, component) => (total += component.assessedValue),
                            0,
                        );

                        if (totalAV.assessedValue < 0) {
                            totalAV.assessedValue = 0;
                            totalAV.hadNegativeAssessedValue = true;
                        }

                        if (totalAV.marketValue < 0) {
                            totalAV.marketValue = 0;
                            totalAV.hadNegativeMarketValue = true;
                        }

                        totalAV.taxAmount =
                            this._applyEqualizationFactorPreview(totalAV.assessedValue) * taxAuthority.rate;

                        let alternativeAV = {
                            assessedValue: 0,
                        } as TaxableValueInfo;

                        const hasAltComponents = taxableComponents.some(
                            (y) => y.assessmentComponentTypeID === AssessmentComponentTypeEnum.Cap,
                        );

                        if (hasAltComponents) {
                            let alternateComponents: AnnualAssessmentDetail[];
                            if (taxAuthority.allowExemptionsOnAlternateAV) {
                                alternateComponents = [
                                    ...taxableComponents.filter(
                                        (y) => y.assessmentComponentTypeID === +AssessmentComponentTypeEnum.Cap,
                                    ),
                                    ...exemptions,
                                ];
                            } else {
                                alternateComponents = [
                                    ...taxableComponents.filter(
                                        (y) => y.assessmentComponentTypeID === +AssessmentComponentTypeEnum.Cap,
                                    ),
                                ];
                            }

                            alternativeAV = alternateComponents.reduce(
                                (taxableTotal, component) => {
                                    taxableTotal.assessedValue += component.assessedValue;
                                    taxableTotal.marketValue += component.fairMarketValue;

                                    return taxableTotal;
                                },
                                { assessedValue: 0, marketValue: 0 } as TaxableValueInfo,
                            );
                            alternativeAV.taxAuthorityId = taxAuthority.taxAuthorityId;
                            alternativeAV.taxAuthorityName = taxAuthority.taxAuthorityName;
                            alternativeAV.taxAuthorityCategory = taxAuthority.taxAuthorityCategoryName;

                            if (taxAuthority.allowExemptionsOnAlternateAV) {
                                alternativeAV.adjustmentAssessedValue = exemptions.reduce(
                                    (total, component) => (total += component.assessedValue),
                                    0,
                                );
                            } else {
                                alternativeAV.adjustmentAssessedValue = 0;
                            }

                            if (alternativeAV.assessedValue < 0) {
                                alternativeAV.assessedValue = 0;
                                alternativeAV.hadNegativeAssessedValue = true;
                            }

                            if (alternativeAV.marketValue < 0) {
                                alternativeAV.marketValue = 0;
                                alternativeAV.hadNegativeMarketValue = true;
                            }

                            alternativeAV.taxAmount =
                                this._applyEqualizationFactorPreview(alternativeAV.assessedValue) * taxAuthority.rate;
                        }

                        const useAlternativeAV =
                            hasAltComponents && alternativeAV.assessedValue < totalAV.assessedValue;
                        taxableAssessmentName = useAlternativeAV ? 'Alternate AV' : 'Total AV';
                        alternativeAV.taxableAssessmentName = taxableAssessmentName;
                        totalAV.taxableAssessmentName = taxableAssessmentName;

                        if (useAlternativeAV) {
                            alternativeAV.assessedValue = this._applyEqualizationFactorPreview(
                                alternativeAV.assessedValue,
                            );
                            taxableValues.push(alternativeAV);
                        } else {
                            totalAV.assessedValue = this._applyEqualizationFactorPreview(totalAV.assessedValue);
                            taxableValues.push(totalAV);
                        }
                    }
                });
            } else {
                const normalComponents: AnnualAssessmentDetail[] = this.viewModel.model.annualAssessmentDetails.filter(
                    (y) =>
                        y.assessmentComponentTypeID === AssessmentComponentTypeEnum.Normal ||
                        y.assessmentComponentTypeID === AssessmentComponentTypeEnum.Adjustment,
                );
                const alternateComponents: AnnualAssessmentDetail[] =
                    this.viewModel.model.annualAssessmentDetails.filter(
                        (y) => y.assessmentComponentTypeID === AssessmentComponentTypeEnum.Cap,
                    );

                const normalComponentsTaxableValue = normalComponents.reduce(
                    (taxableTotal, component) => {
                        taxableTotal.assessedValue += component.assessedValue;
                        taxableTotal.marketValue += component.fairMarketValue;

                        return taxableTotal;
                    },
                    { assessedValue: 0, marketValue: 0 } as TaxableValueInfo,
                );

                if (normalComponentsTaxableValue.assessedValue < 0) {
                    normalComponentsTaxableValue.assessedValue = 0;
                    normalComponentsTaxableValue.hadNegativeAssessedValue = true;
                }

                if (normalComponentsTaxableValue.marketValue < 0) {
                    normalComponentsTaxableValue.marketValue = 0;
                    normalComponentsTaxableValue.hadNegativeMarketValue = true;
                }

                const alternateComponentsTaxableValue = alternateComponents.reduce(
                    (taxableTotal, component) => {
                        taxableTotal.assessedValue += component.assessedValue;
                        taxableTotal.marketValue += component.fairMarketValue;

                        return taxableTotal;
                    },
                    { assessedValue: 0, marketValue: 0 } as TaxableValueInfo,
                );

                if (alternateComponentsTaxableValue.assessedValue < 0) {
                    alternateComponentsTaxableValue.assessedValue = 0;
                    alternateComponentsTaxableValue.hadNegativeAssessedValue = true;
                }

                if (alternateComponentsTaxableValue.marketValue < 0) {
                    alternateComponentsTaxableValue.marketValue = 0;
                    alternateComponentsTaxableValue.hadNegativeMarketValue = true;
                }

                const selectedTaxableValue =
                    alternateComponentsTaxableValue.assessedValue < normalComponentsTaxableValue.assessedValue &&
                    alternateComponents.length !== 0
                        ? alternateComponentsTaxableValue
                        : normalComponentsTaxableValue;
                selectedTaxableValue.assessedValue = this._applyEqualizationFactorPreview(
                    selectedTaxableValue.assessedValue,
                );
                taxableValues.push(selectedTaxableValue);
            }

            taxableValues = this._getUniqueTaxable(taxableValues);
            taxableValues.sort((x, y) =>
                y.taxAmount != x.taxAmount ? y.taxAmount - x.taxAmount : y.assessedValue - x.assessedValue,
            );

            if (this.viewModel.model?.canRecalculateTaxableValue) {
                this.taxableValues = this._preserveTaxableValueIds(taxableValues, this._getSavedTaxableValues());
                this.viewModel.model.taxableValues = this.taxableValues;
                this.viewModel.model.hasNegativeTaxable = taxableValues.some(
                    (x) => x.hadNegativeAssessedValue || x.hadNegativeMarketValue,
                );
            } else if (this.taxableValues.length !== 0) {
                for (let i = 0; i < this.taxableValues.length; i += 1) {
                    let currentValue = this.taxableValues[i];
                    const calculatedValue = taxableValues.find(
                        (y) =>
                            y.assessedValue === currentValue.assessedValue &&
                            y.marketValue === currentValue.marketValue &&
                            this._roundTaxAmount(y.taxAmount) === this._roundTaxAmount(currentValue.taxAmount),
                    );

                    if (calculatedValue) {
                        currentValue = {
                            ...calculatedValue,
                            annualAssessmentTaxableValueId: currentValue.annualAssessmentTaxableValueId,
                        };
                    } else {
                        currentValue.hasConfigurationChanged = true;
                    }
                    this.taxableValues[i] = currentValue;
                }
                this.viewModel.model.taxableValues = this.taxableValues;
                this.viewModel.model.hasNegativeTaxable = taxableValues.some(
                    (x) => x.hadNegativeAssessedValue || x.hadNegativeMarketValue,
                );
            }
        }
    }

    // A parcel without a Tax Authority has no tax amount on its calculated or its saved taxable values.
    private _roundTaxAmount(taxAmount: number | null | undefined): number {
        return parseFloat((taxAmount ?? 0).toFixed(2));
    }

    // Shows the rows Prior Year Setup would give this year. They carry no id and are not flagged as edited, so Save never
    // sends them: the server copies the prior Tax Year's setup itself.
    private previewPriorYearSetup(): void {
        this.taxableValues = (this.viewModel.model.priorYearTaxableValues ?? []).map(
            (x) =>
                ({
                    annualAssessmentTaxableValueId: undefined,
                    assessedValue: x.assessedValue,
                    marketValue: x.marketValue,
                    taxAmount: x.taxAmount,
                    sequence: x.sequence,
                    description: x.description,
                    taxAuthorityIds: [],
                }) as TaxableValueInfo,
        );
        this.viewModel.model.taxableValues = this.taxableValues;
        this.viewModel.model.deletedTaxableValues = [];
        this.viewModel.model.taxableValuesEdited = false;
    }

    // The rows the server last returned are what the ids have to come from: every save can replace the saved rows with
    // new ones, so the ids on the rows shown here can be from before the latest save.
    private _getSavedTaxableValues(): Core.AnnualAssessmentTaxableValue[] {
        const savedValues = this.viewModel.persistedTaxableValues;

        return savedValues?.length ? savedValues : this.taxableValues;
    }

    private _preserveTaxableValueIds(
        calculatedValues: TaxableValueInfo[],
        existingValues: Core.AnnualAssessmentTaxableValue[],
    ): TaxableValueInfo[] {
        const matchedIds = matchTaxableValueIds(calculatedValues, existingValues);

        return calculatedValues.map((calculatedValue, index) =>
            matchedIds[index] === undefined
                ? calculatedValue
                : { ...calculatedValue, annualAssessmentTaxableValueId: matchedIds[index] },
        );
    }

    private _recalculateCapValue() {
        const capRuleInfo = this.viewModel.model.capRuleInfo;

        if (!this.viewModel.currentYear.calcCapProjected || !capRuleInfo) {
            return;
        }

        const capComponent = this.viewModel.model.annualAssessmentDetails.find(
            (x) => x.assessmentComponentTypeID === AssessmentComponentTypeEnum.Cap,
        );

        if (capComponent) {
            const normalComponentsAssessedValue = this.viewModel.model.annualAssessmentDetails
                .filter((x) => x.assessmentComponentTypeID === AssessmentComponentTypeEnum.Normal)
                .map((x) => x.assessedValue)
                .reduce((acct, cur) => acct + cur, 0);
            let projectedCapAssessedValue =
                capRuleInfo.priorYearCapRuleAssessedValue +
                capRuleInfo.priorYearCapRuleAssessedValue * capRuleInfo.percentIncrease;

            if (!capRuleInfo.capValueRange || projectedCapAssessedValue <= capRuleInfo.capValueRange) {
                if (projectedCapAssessedValue <= normalComponentsAssessedValue || capRuleInfo.mayExceedAV) {
                    capComponent.assessedValue = projectedCapAssessedValue;
                } else {
                    capComponent.assessedValue = normalComponentsAssessedValue;
                }
            } else {
                capComponent.assessedValue = capRuleInfo.capValueRange;
            }

            capComponent.fairMarketValue = capComponent.assessedValue / capComponent.ratio;
        }
    }

    private _checkCapComponentExistence() {
        if (this.enableCapRule && this.viewModel) {
            const capComponent = this.viewModel.model.annualAssessmentDetails.find(
                (x) => x.assessmentComponentTypeID === AssessmentComponentTypeEnum.Cap,
            );

            this.hasCapComponent = !!capComponent;
            this.capComponentName = capComponent?.componentName;
        }
    }
}
